/* eslint-disable no-useless-catch */
import { serialize } from '../utils';
import { FindOneOptions, FindOptions } from './common';
import { entityService } from './services';
// #endregion Local Imports

const pathname = '/employees';

export const EmployeeApi = {
  find: async (option: FindOptions) => {
    let url = pathname;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findEmployeeWithGroup: async (option: any) => {
    let url = `${pathname}/filter-with-group`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findEntityAssignToUser: async (option: any) => {
    let url = `${pathname}/find-entity-assign-to-user`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findAccountToCreateEmployee: async (
    options: FindAccountToCreateEmployeeQuery
  ) => {
    let url = `${pathname}/find-employee-group-with-user`;
    const query = serialize(options);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  create: async (body: any) => {
    try {
      const response = await entityService.post(pathname, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  createWithUser: async (body: any) => {
    try {
      const url = `${pathname}/create-with-user`;
      const response = await entityService.post(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },
  findOneEmployee: async (id: string) => {
    const url = `${pathname}/user/${id}`;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },
  findOne: async (id: string, option: FindOneOptions) => {
    let url = `${pathname}/${id}`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  update: async (id: string, body: any = {}) => {
    const url = `${pathname}/${id}`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },
  updateEmployeeUser: async (id: string, body: any = {}) => {
    const url = `${pathname}/user/${id}`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  updateStatus: async (id: string, body: any = {}) => {
    const url = `${pathname}/${id}/status`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  updateEmployeeUserStatus: async (id: string, body: any = {}) => {
    const url = `${pathname}/user/${id}/status`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  delete: async (id: string) => {
    const url = `${pathname}/${id}`;

    try {
      const response = await entityService.delete(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  deleteEmployeeUser: async (id: string) => {
    const url = `${pathname}/user/${id}`;

    try {
      const response = await entityService.delete(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  checkDuplicate: async (option?: CheckDuplicateEmployeeCodeQuery) => {
    let url = `${pathname}/check-duplicate`;
    const query = serialize(option || {});
    url += query;
    try {
      const response = await entityService.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  checkDuplicateEmployeeCode: async (
    option?: CheckDuplicateEmployeeCodeQuery
  ) => {
    let url = `${pathname}/user/check-duplicate`;
    const query = serialize(option || {});
    url += query;
    try {
      const response = await entityService.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  generateEmployeeUserCode: async (option: GenerateEmployeeCodeQuery) => {
    let url = `${pathname}/user/generate-code`;
    const query = serialize(option);
    url += query;
    try {
      const response = await entityService.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  },
};

export interface DeleteEmployeeBody {
  ownerID: string;
}

export interface CheckDuplicateEmployeeCodeQuery {
  code: string;
  entityID?: string;
}

export interface GenerateEmployeeCodeQuery {
  entityID?: string;
}

export interface FilterEmployeeOptions {
  page?: number;
  take?: number;
  order?: any;
  reserved?: boolean;
  name?: string;
  entityIDs?: string;
  status?: number;
  type?: number;
}

export interface FindAccountToCreateEmployeeQuery {
  page: number;
  take: number;
  order?: any;
  phoneNumber: string;
}
